import React from 'react';
import { EyeIcon, CheckCircleIcon, ClockIcon, BookOpenIcon, CalendarIcon, ShieldCheck } from 'lucide-react';
const HeaderGlpInvestigationE = () => {
  return <header className="bg-white" style={{
    fontFamily: 'Georgia, Cambria, "Times New Roman", serif'
  }} data-id="element-17881" data-mp="lsboazcx28ca">
      {/* Top black bar */}
      <div className="bg-black h-3 w-full" data-id="element-17882" data-mp="bzw6q35j7lrx"></div>

      {/* Masthead section */}
      <div className="border-b border-gray-800 px-4 sm:px-6 py-4 sm:py-6" data-id="element-17883" data-mp="zq061yboszd4">
        <div className="text-center pb-3 sm:pb-4 mb-3 sm:mb-4" data-id="element-17884" data-mp="znx7ur0drzxb">
          <h2 className="font-serif text-2xl sm:text-3xl font-bold tracking-tight text-gray-900" data-id="element-17885" data-mp="14o1n6dpjyoly">
            TRADITIONAL MEDPUB
          </h2>
          <div className="text-xs uppercase tracking-widest text-gray-500 mt-2 font-medium" data-id="element-17886" data-mp="qro7990o2v9l">
            INDEPENDENT HEALTH INVESTIGATIONS SINCE 1982
          </div>
        </div>

        <div className="flex flex-col sm:grid sm:grid-cols-3 text-xs text-gray-600 border-b border-gray-300 pb-2 gap-1 sm:gap-0" data-id="element-17887" data-mp="3be9bo6xbap36">
          <div className="text-left" data-id="element-17888" data-mp="1dvyehsj6doay">VOL. 128, NO. 43</div>
          <div className="text-left sm:text-center" data-id="element-17889" data-mp="1dwhswz9m9uk8">
            {(() => {
            const yesterday = new Date();
            yesterday.setDate(yesterday.getDate() - 1);
            return yesterday.toLocaleDateString('en-US', {
              weekday: 'long',
              month: 'long',
              day: 'numeric',
              year: 'numeric'
            }).toUpperCase();
          })()}
          </div>
          <div className="text-left sm:text-right" data-id="element-17890" data-mp="1wsr6llglwj3p">
            HEALTH & WELLNESS SECTION
          </div>
        </div>
      </div>

      {/* Article header */}
      <div className="px-4 sm:px-6 py-6 border-b border-gray-200" data-id="element-17891" data-mp="26jlromi49cnk">
        <div className="max-w-4xl mx-auto" data-id="element-17892" data-mp="21lsp03g0v0s1">
          <div className="uppercase text-xs tracking-wider text-gray-500 font-medium border-b border-gray-200 pb-2 mb-4" data-id="element-17893" data-mp="21mvh2ep2z99j">
            INVESTIGATIVE REPORT
          </div>

          <h1 className="font-serif text-2xl sm:text-4xl font-bold text-gray-900 leading-tight mb-5" data-id="element-17894" data-mp="2an099hlpe134">
            GLP-1 & MENTAL HEALTH - MAJOR BREAKTHROUGH
          </h1>

          <div className="flex items-start mb-5 border-b border-gray-200 pb-5" data-id="element-17895" data-mp="1d7x819jp4db0">
            <div className="w-14 h-14 overflow-hidden rounded-full flex-shrink-0 mr-4 border border-gray-300" data-id="element-17896" data-mp="1d5t790h3fuey">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/3QGeAdkaxHnkiYL33dUYdV/Tom_Parham.jpg" alt="Dr. Tom Parham" className="w-full h-full object-cover" data-id="element-17897" data-mp="1m07i8qulcis9" />
            </div>
            <div className="flex-1" data-id="element-17898" data-mp="1r1ohkhxffx6q">
              <div className="flex items-center" data-id="element-17899" data-mp="1vxlyoqgil7kk">
                <div className="font-medium text-gray-900 text-lg" data-id="element-17900" data-mp="1w0hxsi43m2al">
                  By Dr. Tom Parham, MD, FACE
                </div>
                <div className="ml-2 flex items-center text-blue-600" data-id="element-17901" data-mp="24ytnmhx54w1z">
                  <CheckCircleIcon className="h-4 w-4" data-id="element-17902" data-mp="24wqx7ws2t0wq" />
                  <span className="text-xs ml-1 font-medium" data-id="element-17903" data-mp="6ks9692r9rt9">Verified</span>
                </div>
              </div>
              <div className="text-sm text-gray-600 mb-2" data-id="element-17904" data-mp="alkggws2hmmw">
                Board-Certified Endocrinologist, 30 Years Clinical Practice
              </div>
              <div className="flex text-xs text-gray-500 items-center" data-id="element-17905" data-mp="3ufp524ebuvph">
                <div className="flex items-center mr-4" data-id="element-17906" data-mp="3uedzbz1bndvq">
                  <ClockIcon className="h-3 w-3 mr-1" data-id="element-17907" data-mp="3phxdxclibdmc" />
                  <span data-id="element-17908" data-mp="3lfskoeyz0j08">14 min read</span>
                </div>
                <div className="flex items-center" data-id="element-17909" data-mp="3lhdfm5p763ym">
                  <EyeIcon className="h-3 w-3 mr-1" data-id="element-17910" data-mp="m0nk50dlfhyp" />
                  <span data-id="element-17911" data-mp="lyb26n7u57ln">31,542 views</span>
                </div>
              </div>
              <div className="flex items-center text-xs text-gray-500 mt-1" data-id="element-17912" data-mp="h23w8uffvw3p">
                <ShieldCheck className="h-3.5 w-3.5 text-blue-600 mr-1 flex-shrink-0" data-id="element-17913" data-mp="cyny1tnq1now" />
                Medically Reviewed by{' '}
                <span className="text-blue-600 underline ml-1" data-id="element-17914" data-mp="82ql7xbo2zgv">
                  Robert Hill, MD, FACP
                </span>
              </div>
            </div>
          </div>

          <p className="font-serif text-gray-700 text-base sm:text-lg mb-6 leading-relaxed border-l-4 border-gray-300 pl-4 italic" data-id="element-17915" data-mp="2spa90pk6l9b7">
            After three decades in endocrinology, I've prescribed thousands of
            medications. But when patients on semaglutide started reporting
            severe depression—and regulatory agencies ignored it—I decided to
            run a 16-month investigation. What I discovered will save you
            sleepless nights - and might actually change your life.
          </p>

          <div className="border-t border-gray-200 pt-3 text-xs text-gray-500 flex flex-wrap justify-between" data-id="element-17916" data-mp="136k3m7zppl92">
            <div className="mb-1 flex items-center" data-id="element-17917" data-mp="185dju86dvqcx">
              <span className="font-medium mr-2" data-id="element-17918" data-mp="u76szbzuqqmr">Published by:</span>
              Traditional Medicine Publications
            </div>
            <div className="mb-1 flex items-center" data-id="element-17919" data-mp="z95xip7bvtla">
              <span className="font-medium mr-2" data-id="element-17920" data-mp="3ex5y7dpiillo">Published:</span>
              {(() => {
              const yesterday = new Date();
              yesterday.setDate(yesterday.getDate() - 1);
              return yesterday.toLocaleDateString('en-US', {
                month: 'long',
                year: 'numeric'
              });
            })()}
            </div>
          </div>
        </div>
      </div>

      {/* Author image */}
      <div className="px-4 sm:px-8 py-6 border-b border-gray-200" data-id="element-17921" data-mp="3ldo7vzmdqthh">
        <div className="max-w-4xl mx-auto" data-id="element-17922" data-mp="3gge9huh0j7hi">
          <div className="sm:flex items-center" data-id="element-17923" data-mp="3gdjtqg8y2auf">
            <div className="sm:w-1/3 mb-4 sm:mb-0 sm:mr-6" data-id="element-17924" data-mp="2sqtqjbkv0a88">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/3QGeAdkaxHnkiYL33dUYdV/Tom_Parham.jpg" alt="Dr. Tom Parham in medical office" className="w-full rounded-lg shadow-md" data-id="element-17925" data-mp="2nqpcrtbc5tlp" />
            </div>
            <div className="sm:w-2/3" data-id="element-17926" data-mp="2xp515oizaori">
              <p className="text-sm text-gray-700 mb-2" data-id="element-17927" data-mp="2xo3h4ujzirxn">
                <span className="font-bold" data-id="element-17928" data-mp="29z109ox6d347">Dr. Tom Parham, MD, FACE</span> is a
                board-certified endocrinologist with 30 years of clinical
                experience specializing in diabetes management and metabolic
                disorders. Throughout his career, he has evaluated hundreds of
                pharmaceutical treatments and their long-term effects on
                patients.
              </p>
              <p className="text-sm text-gray-700" data-id="element-17929" data-mp="inxidnfulzgi">
                His investigative work focuses on identifying and solving
                medication side effects that fall through the cracks of official
                approval processes, helping patients achieve health outcomes
                without sacrificing quality of life.
              </p>
            </div>
          </div>
        </div>
      </div>
    </header>;
};
export default HeaderGlpInvestigationE;